import { Component, computed, input } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { KorviuInputComponent } from 'shared/components/korviu-input/korviu-input.component';
import { KorviuSelectComponent } from 'shared/components/korviu-select/korviu-select.component';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { IIdValue } from 'shared/types/id-value.interface';
import {
  getTaxDocumentFormNameKey,
  getTaxDocumentResidencySuffixKey,
  TAX_DOCUMENT_ORIGINAL_FORM_URLS
} from '../tax-documentation-contract.helpers';

@Component({
  selector: 'app-tax-documentation-w9-step',
  imports: [TranslatePipe, ReactiveFormsModule, KorviuInputComponent, KorviuSelectComponent, NzRadioModule],
  templateUrl: './tax-documentation-w9-step.component.html',
  styleUrl: '../tax-documentation-modal.component.scss'
})
export class TaxDocumentationW9StepComponent {
  readonly originalFormUrl = TAX_DOCUMENT_ORIGINAL_FORM_URLS.W9;
  readonly formNameKey = getTaxDocumentFormNameKey('W9');
  readonly residencySuffixKey = getTaxDocumentResidencySuffixKey('W9');

  form = input.required<FormGroup>();
  usCountryControl = input.required<FormControl<string>>();
  taxIdTypeControl = input.required<FormControl<'ssn' | 'ein'>>();
  taxIdLabel = input.required<string>();
  taxIdPlaceholder = input.required<string>();
  taxIdMask = input.required<string>();
  taxIdMaskErrorKey = input.required<string>();
  federalTaxClassifications = input.required<IIdValue[]>();
  llcClassifications = input.required<IIdValue[]>();

  fullLegalNameControl = computed(() => this.getControl('fullLegalName'));
  streetAddressControl = computed(() => this.getControl('streetAddress'));
  cityControl = computed(() => this.getControl('city'));
  zipCodeControl = computed(() => this.getControl('zipCode'));
  stateControl = computed(() => this.getControl('state'));
  taxIdNumberControl = computed(() => this.getControl('taxIdNumber'));
  federalTaxClassificationControl = computed(() => this.getControl('federalTaxClassification'));
  llcClassificationControl = computed(() => this.getControl('llcClassification'));

  get isLlcSelected(): boolean {
    return this.federalTaxClassificationControl()?.value === 'llc';
  }

  private getControl(controlName: string): AbstractControl {
    return this.form().get(controlName);
  }
}
